export default {
  f0ce7b4210a49dcc286af408b1b67577: '"Editor',
  '3ab7db03ccec8770024876ced606b4ea': 'Set as default address',
  '211548e7dc2798b699348397c2b98c65': 'Delete'
};
